import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import axios from 'axios';
import pt from './pt.json';
import en from './en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pt: { translation: pt },
      en: { translation: en },
    },
    fallbackLng: 'pt',
    supportedLngs: ['pt', 'en'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'tk-lang',
    },
    react: { useSuspense: false },
  });

// Force default to PT-BR unless user has explicitly set
if (!window.localStorage.getItem('tk-lang')) {
  i18n.changeLanguage('pt');
}

// Sync the Accept-Language header on every API call so the backend can persist
// the user's chosen language on public registrations (emails will be bilingual).
const applyLang = (lng) => {
  axios.defaults.headers.common['Accept-Language'] = lng === 'en' ? 'en' : 'pt-BR';
};
applyLang(i18n.resolvedLanguage || i18n.language || 'pt');
i18n.on('languageChanged', applyLang);

export default i18n;
